export { default as ConfirmPipe } from './ConfirmPipe'
